import React from 'react';
import ReactDOM from 'react-dom';

import { router } from './app'

const app = () => (<React.StrictMode>{ router() }</React.StrictMode>)
const rootElement = document.getElementById('root')

ReactDOM.render(app(), rootElement);
